import * as React from 'react';
import { IComponentProps } from './../../common';


export interface IExpanderProps extends IComponentProps {
    isExpanded: boolean;
    onExpand?: () => void;
    onCollapse?: () => void;
    title?: string;
    inLine?: boolean;
}

export const PlusMinusExpander: React.FC<IExpanderProps> = (props) => {
    if (props.isExpanded) {
        return <span onClick={() => props.onCollapse && props.onCollapse()} className={props.className}>-</span>
    }
    else {
        return <span onClick={() => props.onExpand && props.onExpand()} className={props.className}>+</span>
    }
}

export const CaretExpander: React.FC<IExpanderProps> = (props: IExpanderProps) => {
    const [isExpanded, toggleExpanded] = React.useState<boolean>(props.isExpanded);

    const handleToogle = () => {
        if (isExpanded && props.onCollapse) {
            props.onCollapse();
        }
        toggleExpanded(!isExpanded);
    }

    return <div className={`w-100 expander ${props.className} ${props.inLine ? 'inline' : ''}`}>
        <div className="expander-header" onClick={() => { handleToogle(); }}>
            <span>{props.title}</span>
            <span className={`fa ${isExpanded ? 'fa-caret-down' : 'fa-caret-up'}`}></span>
        </div>
        {
            isExpanded &&
            <div className="expander-content">
                {props.children}
            </div>
        }
    </div>
}


